var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink24Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16H10C6.7 16 4 13.3 4 10C4 6.7 6.7 4 10 4H18V0H10C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20H18V16ZM30 0H22V4H30C33.3 4 36 6.7 36 10C36 13.3 33.3 16 30 16H22V20H30C35.52 20 40 15.52 40 10C40 4.48 35.52 0 30 0ZM28 8H12V12H28V8Z",
    fill: "#007CAD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link_24px.496bdb8d1b1b2f7e8657976c852c4452.svg";